import { Lock } from "lucide-react";
import { tabName } from "./vbUtils";

function SampleForm({ r }) {
  const lx = r.lexicon || {};
  const cats = r.categories?.length ? r.categories : ["Sample"];
  const box = "border border-border bg-background px-2 h-8 text-xs flex items-center text-muted-foreground";
  if (r.flow === "order") {
    return cats.slice(0, 3).map((c, i) => (
      <div key={c} className="flex items-center justify-between border-b border-border py-2 text-xs">
        <span>{c} sample</span><span className="text-muted-foreground">${(10 + 5 * i).toFixed(2)}</span>
      </div>
    ));
  }
  if (r.flow === "appointment") {
    return (
      <div className="space-y-2">
        <div className={box}>{cats[0]}</div>
        <div className={box}>Any {(lx.provider || "team member").toLowerCase()}</div>
        <div className="grid grid-cols-3 gap-1">{["9:00", "9:30", "10:00"].map((t) => <div key={t} className={`${box} justify-center`}>{t}</div>)}</div>
      </div>
    );
  }
  if (r.flow === "quote") {
    return (
      <div className="space-y-2">
        <div className="flex flex-wrap gap-1">{cats.slice(0, 6).map((c) => <span key={c} className="border border-border px-1.5 py-0.5 text-[11px]">{c}</span>)}</div>
        <div className={`${box} h-14 items-start pt-1`}>Describe the {(lx.order || "job").toLowerCase()}…</div>
        <div className={box}>Name, phone, address</div>
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 gap-2">
      {["Taylor Morgan", "Jamie Chen"].map((n) => (
        <div key={n} className="border border-border p-2 text-xs">
          <div className="h-8 w-8 bg-secondary mb-1" />
          <div className="font-semibold">{n}</div>
          <div className="text-muted-foreground">{lx.provider || "Professional"} · {cats[0]}</div>
        </div>
      ))}
    </div>
  );
}

// Live preview: dashboard tab bar, storefront button and a sample customer form.
export function VerticalPreview({ r, tabs, flows }) {
  return (
    <div className="border border-border bg-secondary/40 p-4 space-y-5 lg:sticky lg:top-4" data-testid="vb-preview">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-2">Owner dashboard</div>
        <div className="flex flex-wrap gap-1 border border-border bg-background p-1" data-testid="vb-preview-tabs">
          {tabs.map((t) => (
            <span key={t} className={`text-[11px] px-2 py-1 ${t === r.default_tab || (!r.default_tab && t === tabs[0]) ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>{tabName(r, t)}</span>
          ))}
        </div>
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-2">Public page</div>
        <div className="border border-border bg-background p-4 space-y-3">
          <div className="font-display font-bold" data-testid="vb-preview-heading">{r.storefront?.catalog_heading || r.lexicon?.catalog || "Services"}</div>
          <SampleForm r={r} />
          <button type="button" className="w-full bg-foreground text-background h-9 text-sm font-semibold" data-testid="vb-preview-cta">{r.storefront?.cta || flows[r.flow]?.cta || "Continue"}</button>
        </div>
      </div>
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        {r.status !== "live" && <Lock className="h-3.5 w-3.5" />}
        {r.status === "live" ? "Owners can pick this on the Cart type wall." : r.status === "coming_soon" ? "Shows locked on the wall." : "Only you can see this draft."}
      </div>
    </div>
  );
}
